// extracted by mini-css-extract-plugin
export default {"DismissibleFlashContainer":"DismissibleFlash-module__DismissibleFlashContainer--OXTxX","dismissButton":"DismissibleFlash-module__dismissButton--zmh6T"};